var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lg-finder',{ref:"finder",attrs:{"id":this.id,"fields":_vm.fields,"placeholder":"Informe o nome do usuario","title":_vm.title,"url":"/api/pessoa","filterBy":"nome","othersFilters":_vm.othersFilters,"filtrarSituacao":""},on:{"onSelect":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }